import type * as types from "./types";

import {
  useQuery,
  type DocumentNode,
  type OperationVariables,
  type QueryResult,
  type TypedDocumentNode,
} from "@apollo/client";
import Bugsnag from "@bugsnag/browser";

import { useClient } from "./use-client";

export function useNorthbeamQuery<
  T,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: DocumentNode | TypedDocumentNode<T, TVariables>,
  options?: types.QueryOptions<T, TVariables>,
): QueryResult<T, TVariables> {
  const client = useClient(options);

  const result = useQuery<T, TVariables>(query, {
    ...options,
    client,
  });

  if (result.error && !options?.doNotRaiseErrorOnFailure) {
    Bugsnag.setContext(
      `GraphQL query failure. \nQuery: ${JSON.stringify(
        query,
      )}\nOptions: ${JSON.stringify(options)}`,
    );
    throw result.error;
  }

  return result;
}
